"use client";

import { Box, Divider, Grid, Typography } from "@mui/material";
import { defaultStyles } from "@components/ThemeRegistry/theme";
import { Chat, MailOutline, Phone } from "@mui/icons-material";

const AppFooter = () => {
	return (
		<Box
			sx={{
				paddingTop: "140px",
			}}>
			<Divider sx={{ borderColor: "#00000026" }} />
			<Box
				sx={{
					paddingLeft: defaultStyles.appPaddingLeft,
					paddingRight: defaultStyles.appPaddingLeft,
					paddingTop: "30px",
					paddingBottom: "30px",
					minHeight: "160px",
					maxHeight: "160px",
					height: "160px",
				}}
			>
				<Grid container spacing={2} columns={16}>
					<Grid item xs={8}>
						<Box >
							<Typography
								sx={
									{
										fontWeight: 500,
										fontSize: "13px",
										lineHeight: "20px"
									}}>
								Need Help? <br></br> Contact Internal Services
							</Typography>
							<Typography
								sx={
									{
										fontWeight: 350,
										fontSize: "13px",
										lineHeight: "20px"
									}}>
								<MailOutline sx={{ fontSize: "18px", marginBottom: "-4px", marginRight: "3px" }} />
								info@cardcompliant.com
							</Typography>
							<Typography
								sx={
									{
										fontWeight: 350,
										fontSize: "13px",
										lineHeight: "20px"
									}}>
								<Phone sx={{ fontSize: "18px", marginBottom: "-4px", marginRight: "3px" }} />
								913.871.7430
							</Typography>
						</Box>

					</Grid>
					<Grid item xs={8}>
						<Typography
							sx={
								{
									fontWeight: 350,
									fontSize: "11px",
									lineHeight: "20px",
									textAlign: "right"
								}}>
							© 2024 Card Compliant LLC
							<br></br> All Rights Reserved | Privacy Policy
						</Typography>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
};

export default AppFooter;
